export const UPDATE_RULE_FILTERS = 'UPDATE_RULE_FILTERS';
export const UPDATE_LEADER_LEVEL = 'UPDATE_LEADER_LEVEL';
export const UPDATE_LEADER_LOGINS = 'UPDATE_LEADER_LOGINS';
export const UPDATE_EMPLOYEE_JOB_LEVEL = 'UPDATE_EMPLOYEE_JOB_LEVEL';
export const UPDATE_COUNTRIES_FILTER = 'UPDATE_COUNTRIES_FILTER';
export const UPDATE_MANAGER = 'UPDATE_MANAGER';
export const UPDATE_DATE_OPERATOR = 'UPDATE_DATE_OPERATOR';
export const UPDATE_HIRE_START_DATE = 'UPDATE_HIRE_START_DATE';
export const UPDATE_HIRE_END_DATE = 'UPDATE_HIRE_END_DATE';
export const UPDATE_METRIC_VALUE = 'UPDATE_METRIC_VALUE';
export const UPDATE_METRIC_NAME = 'UPDATE_METRIC_NAME';
export const UPDATE_METRIC_OPERATOR = 'UPDATE_METRIC_OPERATOR';
export const UPDATE_ACTIVE_FILTERS = 'UPDATE_ACTIVE_FILTERS';
export const UPDATE_DIRECT_REPORTS = 'UPDATE_DIRECT_REPORTS';
export const UPDATE_METRIC_FILTER = 'UPDATE_METRIC_FILTER';
export const RESET_RULE_FILTERS = 'RESET_RULE_FILTERS';
